module.exports = __webpack_public_path__ + "img/2.81a3f104.png";